import React from 'react';
import { Check, Crown } from 'lucide-react';
export function Upsell() {
  const features = ['Guía de medición y fotos comparativas profesionales', 'Checklist imprimible de los 30 días completos', 'Tracker semanal de cargas y progresión', 'Protocolo Plan B para días de 20 minutos', 'Guía de qué hacer después del día 30', 'Cómo repetir el ciclo con mayor carga', 'Señales de alerta que frenan el crecimiento', 'Cómo mantener resultados a largo plazo'];
  return <section className="py-16 md:py-24 px-4 bg-surface/40 border-y border-zinc-800/60" data-id="element-485">
      <div className="max-w-5xl mx-auto" data-id="element-486">
        <div className="text-center mb-10 md:mb-14" data-id="element-487">
          <p className="text-primary font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3 flex items-center justify-center gap-2" data-id="element-488">
            <Crown className="w-4 h-4" data-id="element-489" /> 🔥 ¿Qué agrega el Plan Total?
          </p>
          <h2 className="text-2xl md:text-4xl font-extrabold mb-6 leading-tight max-w-3xl mx-auto" data-id="element-490">
            Porque tener el plan no alcanza{' '}
            <span className="text-primary" data-id="element-491">si no medís el progreso</span>
          </h2>
          <p className="text-base md:text-lg text-zinc-300 leading-relaxed max-w-3xl mx-auto" data-id="element-492">
            El Plan Total agrega las herramientas de seguimiento que te permiten
            ver en números y fotos exactamente cuánto cambió tu cuerpo en 30
            días.
          </p>
        </div>

        <div className="bg-surface border border-primary/30 rounded-3xl p-6 md:p-10 shadow-[0_0_40px_rgba(249,168,212,0.08)] mb-8" data-id="element-493">
          <div className="grid md:grid-cols-2 gap-3 md:gap-4" data-id="element-494">
            {features.map((f, i) => <div key={i} className="flex items-start gap-3 bg-black/30 border border-zinc-800/60 rounded-xl p-3 md:p-4" data-id="element-495">
                <div className="bg-primary/20 p-1.5 rounded-full shrink-0 mt-0.5" data-id="element-496">
                  <Check className="w-3.5 h-3.5 text-primary" data-id="element-497" />
                </div>
                <span className="text-zinc-200 text-sm md:text-base leading-tight" data-id="element-498">
                  {f}
                </span>
              </div>)}
          </div>
        </div>

        <p className="text-center text-base md:text-xl text-zinc-200 leading-relaxed max-w-2xl mx-auto" data-id="element-499">
          Si además de entrenar querés{' '}
          <span className="text-primary font-bold" data-id="element-500">
            asegurar tus resultados,
          </span>{' '}
          esta es tu opción.
        </p>
      </div>
    </section>;
}